export default {
  name: 'WordCloud',
  displayName: {
    en: 'Word Cloud',
    ja: 'ワードクラウド',
  },
  defaultWidth: 375,
  defaultHeight: 164,
  resizeX: true,
  resizeY: true,
  props: [
    {
      name: 'items',
      displayName: {
        en: 'What is this a list of?',
        ja: 'データベースの選択',
      },
      type: 'list',
    },
    {
      name: 'sortList',
      displayName: { en: 'Sorting', ja: '並び替え' },
      type: 'sort',
    },
    {
      name: 'maximumItems',
      displayName: { en: 'Maximum number of items', ja: '最大アイテム数' },
      type: 'maximumItems',
    },
    {
      name: 'blockItems',
      displayName: {
        en: 'Block items',
        ja: 'ブロックアイテム',
      },
      type: 'text',
      disableDynamicValues: true,
      area: true,
    },
  ],
  childComponents: [
    {
      name: 'words',
      displayName: { en: 'Words', ja: '画像' },
      role: 'listItem',
      reference: 'items',
      props: [
        {
          name: 'words',
          displayName: { en: 'Word Source', ja: '単語ソース' },
          type: 'text',
        },
      ],
    },
    {
      name: 'rotation',
      displayName: {
        en: 'Rotation',
        ja: '回転',
      },
      props: [{ name: 'enabled', type: 'boolean', default: true }],
    },
    {
      name: 'padding',
      displayName: {
        en: 'Text Padding',
        ja: 'テキストのパディング',
      },
      props: [
        {
          name: 'paddingSize',
          displayName: {
            en: 'Text Padding',
            ja: 'テキストのパディング',
          },
          type: 'number',
          default: 1,
          control: { type: 'slider', max: 10, min: 1 },
        },
      ],
    },
  ],
};
